import { Component } from '@angular/core';

@Component({
  selector: 'ngx-vale-estar-bem',
  template: `
  <router-outlet></router-outlet>
`,
})
export class ValeEstarBemComponent {

}
